import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface AdminTenantRow {
  tenant_id: string;
  name: string;
  slug: string;
  status: string;
  plan_id: string | null;
  agency_id: string | null;
  agency_email: string | null;
  user_count: number;
  created_at: string;
}

export function useAdminTenants() {
  return useQuery({
    queryKey: ["admin", "tenants"],
    queryFn: async (): Promise<AdminTenantRow[]> => {
      const { data, error } = await supabase.rpc("calie_admin_list_all_tenants");
      
      if (error) {
        throw new Error(error.message);
      }
      
      return (data || []) as AdminTenantRow[];
    },
  });
}
